import ResourceService from "./resource.service";

class GroupsService extends ResourceService {
  static get resource() {
    return "admin/groups";
  }
}

export default GroupsService;
